import { AfterViewInit, Component} from '@angular/core';

declare const $: any;

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements AfterViewInit {

  public images: Array<any> = [];
  public carousel: any;

  constructor() {
    this.initCarousel();
  }

  ngAfterViewInit() {
    this.carousel = $('.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      autoplay: true,
    });
  }

  initCarousel() {
    return new Promise((resolve) => {
      this.images = [
        {
          title: 'Fiabilité',
          anchers: '#fiabilite',
          src: 'assets/img/slider/slider-01-1400x533.jpg',
          src_mobile: 'assets/img/slider/slider-01-mobile.jpg',
          lines: [
            'Conception mécanique',
            'Vin conservé pendant 4 semaines',
            'Un SAV réactif'
          ],
          name: '0'
        },
        {
          title: 'Simplicité',
          anchers: '#simplicite',
          src: 'assets/img/slider/slider-02-1400x533.jpg',
          src_mobile: 'assets/img/slider/slider-02-mobile.jpg',
          lines: [
            'Geste de service naturel',
            'Entretien simple et rapide',
            'Pas de consommable'
          ],
          name: '1'
        },
        {
          title: 'Discrétion',
          anchers: '#discretion',
          src: 'assets/img/slider/slider-03-1400x533.jpg',
          src_mobile: 'assets/img/slider/slider-03-mobile.jpg',
          lines: [
            'Dispositif peu visible',
            'Modèle déposé et breveté',
            'Bec verseur stop-goutte'
          ],
          name: '1'
        }
      ];
      resolve();
    });
  }

  goTo(elem) {
    console.log(elem);
  }
}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/home/slider/slider.component.ts